// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { observer } from "mobx-react";
import CheckBox from "../../../shared/CheckBox";
import { TagItemWithoutDelete } from "../../../ratecards/components/TagItem";
import classNames from "classnames";

const NegotiationWorksheetListItem = observer(
  class extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    constructor(props) {
      super(props);
      this.handleViewDetail = this.handleViewDetail.bind(this);
      this.deleteTag = this.deleteTag.bind(this);
      this.state = {
        updated: false,
      };
    }

    handleViewDetail() {
      this.context.router.push({
        pathname: `/admin/worksheets/${this.props.worksheet.worksheetId}`,
        query: this.context.router.query,
      });
    }

    deleteTag(event: object, tag_id) {
      event.preventDefault();
      event.stopPropagation();
      event.cancelBubble = true;
      event.returnValue = false;
    }

    render() {
      const props = this.props;
      const worksheet = props.worksheet;
      const editing = worksheet.viewState.editing;
      const selected = worksheet.viewState.selected;
      const name = worksheet.worksheetName;
      const country_name = worksheet.country.name;
      const id = worksheet.worksheetId;
      const totalMarkupPercent = !worksheet.totalMarkupPercent
        ? "0%"
        : `${worksheet.totalMarkupPercent}%`;
      const payType = worksheet.payType;

      const tags = worksheet.tags;
      let tagSection = null;
      //console.log('tags', tags);

      const createdDisplay = worksheet.created.format("MMMM D, YYYY");
      let ownerName = "You";
      // let sharedByYou = shared;

      if (String(worksheet.owner.userId) !== String(props.store.currentUser.userId)) {
        ownerName = `${worksheet.owner.firstName} ${worksheet.owner.lastName}`;
        // sharedByYou = false;
      }
      // if (worksheet.owner.email !== localStorage.getItem("PeopleTickerUserEmail")) {
      //   ownerName = worksheet.owner.fullname;
      // }

      let onItemClick = this.props.onClick || this.handleViewDetail;
      let editingSection = null;
      if (editing) {
        onItemClick = worksheet.toggleSelected;
        editingSection = (
          <CheckBox
            type={props.store.allowMultipleItemSelection ? "checkbox" : "radio"}
            name="list-item-select"
            value={name}
            selected={selected}
            style={{ width: 34 }}
            onClick={onItemClick}
          />
        );
      }

      if (tags.length > 0 && !this.props.store.isTagView) {
        tagSection = tags.map((tag) => (
          <TagItemWithoutDelete key={tag.tagId} tag={tag} onClick={this.deleteTag} />
        ));
      }

      return (
        <div className="ratecard-list-item-container">
          <div
            className={classNames("ratecard-list-item", { selected: selected })}
            onClick={onItemClick}
          >
            <div className="ratecard-list-item-left ellipsis">
              {editingSection}
              <div className="ratecard-label-container ellipsis">
                <div className="ratecard-label ellipsis">
                  <span className="ellipsis">{name}</span>
                </div>
                <div className="ratecard-meta ellipsis">
                  <span className="item-subtext-muted">Created by </span>
                  <span className="item-subtext-accent">{ownerName} </span>
                  <span className="item-subtext-muted">on </span>
                  <span className="item-subtext-accent">{createdDisplay}</span>
                </div>
              </div>
            </div>
            <div className="ratecard-list-item-right">
              <div className="ratecard-info w-300 text-center">
                <header data-testid="ID-header-negotiation-worksheets">ID</header>
                <div>{id}</div>
              </div>
              <div className="ratecard-info w-300 text-center">
                <header data-testid="worksheet-type-header-negotiation-worksheets">
                  Worksheet Type
                </header>
                <div>{payType}</div>
              </div>
              <div className="ratecard-info w-300 text-center">
                <header data-testid="country-header-negotiation-worksheets">
                  Country
                </header>
                <div>{country_name}</div>
              </div>
              <div className="ratecard-info w-300 text-center">
                <header data-testid="total-markup-header-negotiation-worksheets">
                  Total Markup
                </header>
                <div>{totalMarkupPercent}</div>
              </div>
              {!editing && (
                <div className="rc-center">
                  {
                    <Link to={`/admin/worksheets/${id}`} className="btn btn-default">
                      View
                    </Link>
                  }
                </div>
              )}
            </div>
            <div className={classNames("tagbox", { "p-left-34": editing })}>
              {tagSection}
            </div>
          </div>
        </div>
      );
    }
  }
);

NegotiationWorksheetListItem.propTypes = {
  store: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default NegotiationWorksheetListItem;
